import { useMemo } from 'react';

import { useUserData } from 'core/Api';
import { convertToInitials } from 'core/Utils';
import { Avatar, Box, Container, Group, Stack, Text } from 'ui';
import { useMatches } from 'ui/Hooks';

import classes from './AccountPageHeader.module.css';

const AccountPageHeader = () => {
  const { data: user } = useUserData();
  const avatarSize = useMatches({
    base: 75,
    sm: 131,
  });

  const initials = useMemo(() => {
    if (!user?.first_name || !user?.last_name) return null;

    return convertToInitials(`${user.first_name} ${user.last_name}`);
  }, [user?.first_name, user?.last_name]);

  return (
    <Box className={classes.AccountPageHeader}>
      <Container size="sm" px={{ base: '0px', sm: 'xs' }}>
        <Group wrap="nowrap">
          <Avatar src={user?.logo?.url} size={avatarSize} radius={avatarSize} color="cobalt">
            {initials}
          </Avatar>
          <Stack gap="2" flex="1">
            <Group miw="0">
              <Text fz="lg" fw={600} className={classes.AccountPageHeader__name}>
                {user?.first_name} {user?.last_name}
              </Text>
            </Group>
            <Group justify="space-between" wrap="nowrap" miw="0">
              <Text className={classes.AccountPageHeader__email} truncate="end">
                {user?.email}
              </Text>
            </Group>
          </Stack>
        </Group>
      </Container>
    </Box>
  );
};

export { AccountPageHeader };
